document.addEventListener('DOMContentLoaded', function () {
  const reviewsContainer = document.querySelector('.custom-reviews');
  const reviews = document.querySelectorAll('.custom-reviews .review');
  const pagination = document.querySelector('.custom-reviews .pagination');
  const reviewsPerPage = 5;
  const totalReviews = reviews.length;
  const totalPages = Math.ceil(totalReviews / reviewsPerPage);

  if (totalReviews === 0) return;

  // Custom slow & smooth scroll function
  function smoothScrollToTop(duration = 800) {
    const start = window.pageYOffset;
    const distance = -start; // always go to top
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1); // 0 → 1

      // Easing function: easeOutQuart (feels very smooth & natural)
      const ease = 1 - Math.pow(1 - progress, 4);

      window.scrollTo(0, start + distance * ease);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  function showPage(page) {
    const start = (page - 1) * reviewsPerPage;
    const end = start + reviewsPerPage;

    reviews.forEach((review, index) => {
      review.style.display = (index >= start && index < end) ? 'block' : 'none';
    });

    // Slow & smooth scroll to the very top of the page
    smoothScrollToTop(800); // 800ms = nice slow animation
  }

  function generatePagination() {
    pagination.innerHTML = '';

    for (let i = 1; i <= totalPages; i++) {
      const button = document.createElement('button');
      button.textContent = i;
      button.addEventListener('click', () => {
        showPage(i);

        // Update active button
        pagination.querySelectorAll('button').forEach(btn => 
          btn.classList.remove('active')
        );
        button.classList.add('active');
      });

      if (i === 1) button.classList.add('active');
      pagination.appendChild(button);
    }
  }

  generatePagination();
  showPage(1); // initial page (already scrolls to top on load if you want)
});